import React, { useMemo } from 'react'
import './login.less'
import { Row, Col } from 'antd'
import { injectIntl, WrappedComponentProps } from 'react-intl'

const Login: React.FC<
  WrappedComponentProps<'intl'> & { children: any; lang: string; setting_params?: any; copy_start_year?: number}
> = (
  props: WrappedComponentProps<'intl'> & { children: any; lang: string; setting_params?: any; copy_start_year?: number},
) => {
  const setting_params = useMemo(() => props.setting_params, [props.setting_params]),
    copy_end_time = new Date().getFullYear(),
    copy_time = useMemo(()=> props?.copy_start_year && props?.copy_start_year === copy_end_time? copy_end_time: `${props.copy_start_year || '1983'}-${copy_end_time}`, [props?.copy_start_year, copy_end_time]);
  const recordStatus = useMemo(()=> window.location.origin.includes('wise-paas.com.cn') ? 'S':
    window.location.origin.includes('wise-paas.cn') ? 'J': '', [])
    return (
    <div className="login-wrapper">
      <Row className="login-content">
        <Col span={24}>
          <Row>
            {(setting_params && Object.keys(setting_params).length > 0 && (
              <div
                className="login-img"
                style={
                  setting_params.loginPageBackgroundImage
                    ? {
                        backgroundImage: `url(${setting_params.loginPageBackgroundImage})`,
                      }
                    : {}
                }
              >
                <div className="signin-body">
                  <div className="signin-left"></div>
                  <div className="signin-right">{props.children}</div>
                </div>
              </div>
            )) || (<div className="login-img" >
              <div className="signin-body">
                <div className="signin-left"></div>
                <div className="signin-right">{props.children}</div>
              </div>
            </div>)}
          </Row>
        </Col>
      </Row>
      <Row className="login-footer">
        <Col>
          {setting_params && Object.keys(setting_params).length && setting_params.loginPageCopyright ? (
            setting_params.loginPageCopyright
          ) : (
            <>&copy; {copy_time} Advantech Co., Ltd.</>
          )}
          {
            recordStatus && <span className="record_num ml-10" onClick={() =>
              window.open('https://beian.miit.gov.cn', '_blank')}>
                {recordStatus === 'S' ? '苏ICP备11055982号-3': '京ICP备18044167号-18'}</span>
          }
        </Col>
      </Row>
    </div>
  )
}

export default injectIntl(Login)
